import React, { useState } from "react";
import { Row, Col } from "antd";
import { Outlet } from "react-router-dom"; // 👈 Add this
import SideBar from "../SideBar/SideBar";
import Header from "../Header/Header";
import { MenuOutlined } from "@ant-design/icons";
import "./layout.css";

const Layout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);
  const closeSidebar = () => setIsSidebarVisible(false);

  return (
    <div className="layout-wrapper">
      {/* Hamburger Icon */}
      <div className="hamburger-menu">
        <MenuOutlined
          onClick={toggleSidebar}
          style={{ fontSize: "24px", cursor: "pointer" }}
        />
      </div>

      <Row className="layout-body" align="top" style={{ flex: 1, margin: 0 }}>
        {/* <Col
          xs={isSidebarVisible ? 20 : 0}
          sm={isSidebarVisible ? 20 : 0}
          md={isSidebarVisible ? 20 : 0}
          lg={3}
          xl={3}
          className="sidebar-col"
        >
          <SideBar closeSidebar={closeSidebar} />
        </Col> */}

        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="content-col">
          <div className="content-container">
            <Header />
            <main className="main-content">
              <Outlet />
            </main>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Layout;
